<template>
  <validation-observer id="tipologia-anel-simulacao" v-slot="{ valid }">
    <validation-helper :interceptor="valid" @isValid="$emit('stepReleased', $event)" />
    <v-row>
      <v-col cols="12">
        <v-alert dense outlined type="info" color="blue">
          <div>
            O fator de saneamento será escolhido de acordo com a
            <strong>ordem</strong>
            de prioridade abaixo:
            <br />
            <ol>
              <li>Se indicado que possui obra na Base Contábil:</li>
              <ol>
                <li>
                  Arquivo de % de Fatores de Saneamento por Obra, utilizando o
                  <strong>Código de Obra</strong>
                </li>
                <li>
                  Resultado de Saneamento do VOC vinculado, utilizando o
                  <strong>Código de Obra</strong>
                </li>
              </ol>
              <li>
                Resultado de Saneamento do VOC vinculado, utilizando a
                <strong>Tipologia</strong>
              </li>
              <li>
                Percentual informado manualmente por
                <strong>Tipologia</strong>
              </li>
            </ol>
          </div>
        </v-alert>
      </v-col>
    </v-row>

    <v-expansion-panels :value="possuiObra ? 0 : 1" class="my-2">
      <v-expansion-panel>
        <v-expansion-panel-header id="arquivo-fatores-por-obra">
          <span style="font-size: 15px !important">Arquivo de % de Fatores de Saneamento por Obra</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row>
            <v-col cols="12">
              <v-alert dense outlined type="info" color="blue">
                <div>
                  <a href="javascript:void(0)" @click="baixarArquivoModeloPercSaneamentoObra()">Clique aqui</a>
                  para baixar o modelo para a importação.
                  <br />
                  OBS: O arquivo deve conter as seguintes colunas:
                  <b>{{ arquivoPercSaneamentoObra.cabecalho.join(', ') }}</b>
                  (exatamente nessa ordem e com esses nomes).
                  <br />
                  OBS²: O arquivo enviado precisa estar no formato
                  <b>UTF-8</b>
                  .
                </div>
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <validation-provider v-slot="{ errors }">
                <v-file-input
                  v-model="arquivoPercSaneamentoObra.fileObj"
                  label="Arquivo CSV"
                  placeholder="Selecione um arquivo CSV"
                  outlined
                  accept=".csv, .zip"
                  truncate-length="30"
                  loader-height="4"
                  :success="arquivoPercSaneamentoObra.id && arquivoPercSaneamentoObra.fileObj ? true : false"
                  :error-messages="errors"
                  :loading="arquivoPercSaneamentoObra.uploading"
                  @change="uploadNewArquivoPercSaneamentoObra($event)"
                  @click:clear="clearInputArquivoPercSaneamentoObra()"
                />
              </validation-provider>
              <validation-provider>
                <input type="hidden" name="validate-upload-arquivo-fatores-por-obra" :value="arquivoPercSaneamentoObra.id" />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row class="mb-n5 mt-n2 mx-auto">
            <v-col cols="12" class="pl-n1 pt-0">
              <parametros-arquivo-csv
                :delimitador.sync="arquivoPercSaneamentoObra.delimitador"
                :involucro.sync="arquivoPercSaneamentoObra.involucro"
                :escape.sync="arquivoPercSaneamentoObra.escape"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-expansion-panels :value="1" class="mt-6">
      <v-expansion-panel>
        <v-expansion-panel-header id="saneamento-voc-simulacao-laudo-express">
          <span style="font-size: 15px !important">Resultado de Saneamento do VOC</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row class="mx-auto">
            <v-col class="cols-percentage pb-0 pr-0" :cols="saneamentoVoc.nome_calculo ? 11 : 12">
              <v-tooltip bottom :disabled="saneamentoVoc.nome_calculo ? false : true">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-bind="attrs"
                    :value="saneamentoVoc.nome_calculo"
                    label="Saneamento do VOC"
                    placeholder="Selecione um cálculo"
                    outlined
                    readonly
                    v-on="on"
                    @focus="dialogSelector = true"
                  />
                </template>
                <span>{{ saneamentoVoc.nome_calculo }}</span>
              </v-tooltip>
            </v-col>
            <v-col v-if="saneamentoVoc.nome_calculo ? true : false" :cols="saneamentoVoc.nome_calculo ? 1 : 0" class="my-4">
              <v-btn icon small color="primary" @click="clearSaneamentoVoc">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
            <dialog-seletor-saneamento-voc :activated.sync="dialogSelector" @selected="setSaneamentoVoc($event)" />
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-expansion-panels class="mt-6">
      <v-expansion-panel>
        <v-expansion-panel-header id="percentual-por-tipologia">
          <span style="font-size: 15px !important">Regras de Fator de Saneamento</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row class="mx-auto">
            <v-col cols="12">
              <v-checkbox
                v-model="desconsiderarExcecoes.incorporacao"
                class="ma-0"
                label="Sanear obras de incorporação"
                hide-details
                dense
              />
            </v-col>
            <v-col cols="12">
              <v-checkbox v-model="desconsiderarExcecoes.doacao" class="ma-0" label="Sanear obras de doação" hide-details dense />
            </v-col>
            <v-col cols="12" class="mb-0">
              <v-checkbox
                v-model="desconsiderarExcecoes.tipologias"
                class="ma-0"
                label="Sanear Tipologias [ANE, GER, RIM, SOL]"
                hide-details
                dense
              />
            </v-col>
            <v-col cols="12" class="mb-0">
              <v-checkbox v-model="desconsiderarExcecoes.servidao" class="ma-0" label="Sanear servidão" hide-details dense />
            </v-col>
            <v-col cols="12" class="mb-0">
              <v-checkbox v-model="desconsiderarExcecoes.estacao_movel" class="ma-0" label="Sanear estação móvel" hide-details dense />
            </v-col>
            <v-col cols="12" class="mb-0">
              <v-checkbox v-model="desconsiderarExcecoes.terreno" class="ma-0" label=" Sanear terreno " hide-details dense />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-expansion-panels class="mt-6">
      <v-expansion-panel>
        <v-expansion-panel-header id="percentual-por-tipologia">
          <span style="font-size: 15px !important">Informar % de Saneamento por Tipologia</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row v-for="(percentual, i) in Object.entries(percentuais)" :key="i" class="mx-auto row-percent">
            <v-col class="cols-title pt-8 px-0" cols="1">
              <v-label>{{ percentual[0] }}</v-label>
            </v-col>
            <v-col class="cols-type pb-0 px-0" :cols="percentual[1].tipoTipologia === 'Informar percentual' ? 5 : 11">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-select
                  no-gutters
                  outlined
                  :value="percentual[1].tipoTipologia"
                  :items="['Informar percentual', 'Saneamento do VOC']"
                  :error-messages="errors"
                  @input="setPercentuais(percentual[0], 'tipoTipologia', $event)"
                  @change="clearTipologia(percentual[0])"
                />
              </validation-provider>
            </v-col>
            <v-col v-if="percentual[1].tipoTipologia === 'Informar percentual'" class="cols-percentage pb-0" cols="6">
              <validation-provider v-slot="{ errors }" rules="between:0,100">
                <v-text-field
                  :value="percentual[1].perc_fator_saneamento"
                  label="Percentual de Saneamento (%)"
                  suffix="%"
                  type="number"
                  min="0"
                  max="100"
                  :error-messages="errors"
                  @input="setPercentuais(percentual[0], 'perc_fator_saneamento', $event)"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </validation-observer>
</template>

<script>
  import ArquivosService from '@/services/ArquivosService';
  import SimulacoesLaudoIncrementaisService from '@/services/SimulacoesLaudosIncrementaisService';

  export default {
    components: {
      ValidationHelper: () => import('@/components/general/ValidationHelper'),
      DialogSeletorSaneamentoVoc: () => import('@/components/general/selectors/GeneralCalculosComCaSelector'),
      ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv')
    },

    emits: ['stepReleased'],

    data: () => ({
      arquivoPercSaneamentoObraUploading: false,
      dialogSelector: false
    }),

    computed: {
      percentuais: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.percentuais;
        }
      },
      saneamentoVoc: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.saneamentoVoc;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', {
            saneamentoVoc: value
          });
        }
      },
      possuiObra: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.possuiObra;
        }
      },
      arquivoPercSaneamentoObra: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoPercSaneamentoObra;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', {
            arquivoPercSaneamentoObra: value
          });
        }
      },
      desconsiderarExcecoes: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.desconsiderarExcecoes;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', {
            desconsiderarExcecoes: value
          });
        }
      }
    },

    methods: {
      setPercentuais(tipologia, key, value) {
        this.$store.dispatch('setSimulacaoLaudoIncremental', {
          percentuais: { [tipologia]: { [key]: value } }
        });
      },

      clearTipologia(tipologia) {
        this.setPercentuais(tipologia, 'perc_fator_saneamento', '100');
      },

      setSaneamentoVoc(value) {
        this.saneamentoVoc = {
          nome_calculo: `#${value.id} - ${value.nome}`,
          saneamento_voc_id: value.id
        };
        this.dialogSelector = false;
      },

      clearSaneamentoVoc() {
        this.saneamentoVoc = {
          nome_calculo: null,
          saneamento_voc_id: null
        };
      },

      baixarArquivoModeloPercSaneamentoObra() {
        this.$toast.info('Processando...', '', { position: 'topRight', timeout: 2000 });

        SimulacoesLaudoIncrementaisService.baixarArquivoModeloPercSaneamentoObra()
          .then(async (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', 'arquivo_modelo_perc_saneamento_obras.csv');
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error('Erro ao baixar arquivo modelo do sistema', '', { position: 'topRight' });
            console.error(err);
          });
      },

      uploadNewArquivoPercSaneamentoObra(arquivo) {
        if (!arquivo) {
          this.clearInputArquivoPercSaneamentoObra();
          return true;
        }

        this.arquivoPercSaneamentoObra.id = '';
        this.arquivoPercSaneamentoObra.uploading = true;

        let formDataWithFile = new FormData();
        formDataWithFile.append('file', arquivo);

        ArquivosService.uploadFile(formDataWithFile)
          .then(async (response) => {
            await this.validaHeader(
              response.data.arquivoId,
              this.arquivoPercSaneamentoObra.delimitador,
              this.arquivoPercSaneamentoObra.involucro,
              this.arquivoPercSaneamentoObra.escape,
              this.arquivoPercSaneamentoObra.cabecalho
            );
            this.arquivoPercSaneamentoObra.id = response.data.arquivoId;
          })
          .catch((err) => {
            const errMessage =
              err?.data?.error_code == 120 || err?.data?.error_code == 121 ? err.data.erro : 'Erro no upload do arquivo.';

            console.error(err);
            this.$toast.error(errMessage, '', {
              position: 'topRight',
              timeout: 4000
            });

            this.arquivoPercSaneamentoObra.fileObj = null;
          })
          .finally(() => (this.arquivoPercSaneamentoObra.uploading = false));
      },

      validaHeader(arquivoId, delimitador, involucro, escape, cabecalhoEsperado) {
        return ArquivosService.validarHeaderCSV(arquivoId, {
          delimitador,
          involucro,
          escape,
          cabecalhoEsperado
        }).catch((err) => {
          throw err;
        });
      },

      clearInputArquivoPercSaneamentoObra() {
        this.arquivoPercSaneamentoObra = {
          id: '',
          fileObj: null
        };
      }
    }
  };
</script>
